import { getSites } from "@/api/ims/api-site-ims"

export const siteKey = "current-sites"

export default {
  namespaced: true,
  state: () => ({
    sites: [],
  }),
  getters: {
    siteSetting(state) {
      return state.sites
    },
    siteOptions(state) {
      return state.sites
        .filter((site) => site.isEnable)
        .map((site) => ({
          value: site.id,
          text: site.name,
        }))
    },
  },
  mutations: {
    SET_SITES(state, sites) {
      state.sites = sites
    },
  },
  actions: {
    async fetchSite({ commit }, isForceFetch = false) {
      const sites = JSON.parse(localStorage.getItem(siteKey))

      if (sites && !isForceFetch) {
        commit("SET_SITES", sites)
      } else {
        try {
          const response = await getSites()
          const siteCurrent = response.data.map((site) => ({
            ...site,
            isEnable: true,
          }))

          commit("SET_SITES", siteCurrent)
          localStorage.setItem(siteKey, JSON.stringify(siteCurrent))
        } catch (error) {
          console.error("Failed to fetch sites:", error)
        }
      }
    },
    setSite({ commit }, sitesUpdate) {
      commit("SET_SITES", sitesUpdate)
      localStorage.setItem(siteKey, JSON.stringify(sitesUpdate))
    },
  },
}
